import { render, staticRenderFns } from "./ProfileTabInfo.vue?vue&type=template&id=2a6809bb&scoped=true"
import script from "./ProfileTabInfo.vue?vue&type=script&lang=js"
export * from "./ProfileTabInfo.vue?vue&type=script&lang=js"
import style0 from "./ProfileTabInfo.vue?vue&type=style&index=0&id=2a6809bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6809bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextField,VTextarea})
